var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityBlueBadgeAccessibleParkingBays = function SvgAccessibilityBlueBadgeAccessibleParkingBays(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M5.368 27.442v1.288a.534.534 0 0 1-.546.546H4.12a.534.534 0 0 1-.546-.546v-1.288m.078-4.877c-.742-.078-1.366-.546-1.327-1.053s.702-.82 1.444-.741q.283.042.546.156m-.039 3.082v.82a.265.265 0 0 0 .273.272h1.99a.265.265 0 0 0 .273-.273v-.35a.29.29 0 0 0-.195-.274l-1.99-.468a.31.31 0 0 0-.351.273zm9.558 3.433v1.288a.534.534 0 0 0 .546.546h.703a.534.534 0 0 0 .546-.546v-1.288"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m15.16 22.097.859 1.483c.203.356.31.76.312 1.17v2.224a.433.433 0 0 1-.43.43h-12.6a.433.433 0 0 1-.43-.43V24.75a2.5 2.5 0 0 1 .312-1.17l.859-1.483m12.289 4.188H2.871m12.289-4.019H4.043"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "M11.26 25.231H7.942m3.318-.819H7.942"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m4.042 22.097 1.287-3.277a.68.68 0 0 1 .663-.429h7.257a.78.78 0 0 1 .663.43l.234.545 1.054 2.731m.312.468c.741-.078 1.365-.546 1.326-1.053s-.702-.82-1.443-.741a2.2 2.2 0 0 0-.547.156m.079 3.082v.82a.265.265 0 0 1-.274.272h-1.99a.265.265 0 0 1-.272-.273v-.35a.29.29 0 0 1 .195-.274l1.99-.468a.31.31 0 0 1 .35.273z"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 24.463,
    cy: 18.313,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "m22.317 25.374-.741-.039c-.04.078-.976 2.185-1.093 2.42a1.03 1.03 0 0 1-.35.545.527.527 0 0 1-.781-.624c.39-1.17.78-2.38 1.17-3.55.04-.117.117-.156.234-.195.742-.078 1.405-.156 2.185-.195l1.054-3.2c.46.155.966.083 1.365-.194a5.6 5.6 0 0 1 1.483 2.067 2.9 2.9 0 0 1-.078 2.536q-.18.373-.43.702c-.156.196-.234.39-.468.469a.495.495 0 0 1-.663-.547c.08-.302.226-.582.43-.819.156-.282.274-.584.35-.897.089-.4-.012-.817-.273-1.132l-.312 1.054"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M25.828 23.93a2.5 2.5 0 0 0-.741-.155 2.797 2.797 0 1 0 2.575 3.004 2.6 2.6 0 0 0-.702-2.068"
  }), /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "m6.927 5.86.079 9.299a.435.435 0 0 0 .431.431h.275a.435.435 0 0 0 .432-.431l.353-4.67h.51l.353 4.67a.435.435 0 0 0 .431.431h.275a.435.435 0 0 0 .432-.431l.039-9.338"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M8.89.642a1.106 1.106 0 1 0 .548.196.8.8 0 0 0-.549-.196m1.766 9.416s1.098.118 1.098-1.216v-3.61c0-1.216-1.06-1.137-1.06-1.137H6.85s-1.06-.079-1.06 1.137v3.61c0 1.334 1.1 1.216 1.1 1.216"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    d: "m17.92 11.196 1.255-5.336m4.709 5.375L22.628 5.86"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M20.98.642a1.106 1.106 0 1 0 .55.196.94.94 0 0 0-.55-.196m.196 14.478-.274-3.924-.275 3.923a.435.435 0 0 1-.431.432h-.157a.435.435 0 0 1-.432-.432l-.157-3.884"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m20.627 15.12.275-3.924.274 3.923c.002.238.194.43.432.432h.157a.435.435 0 0 0 .431-.432l.157-3.884m-2.707.092H17.92"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m22.157 11.314 1.727.065v-.065m-.275-1.962c.275-.079.863-.392.667-1.373-.118-.706-.471-2.158-.706-3.335a.92.92 0 0 0-.903-.746h-3.492a.92.92 0 0 0-.902.746c-.235 1.177-.588 2.629-.706 3.335-.196.98.392 1.294.667 1.373"
  })))));
};
export default SvgAccessibilityBlueBadgeAccessibleParkingBays;